import React from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import EmailsNotSupported from "@app/component/EmailsNotSupported";
import { EntityEmails, EntityEmailsFolder } from "@app/component/EntityEmails";
import TabLayout from "@app/component/preview/components/TabLayout";
import { isEmailServiceSupported } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import { useExtendedAnalytics } from "@app/util/analytic/AnalyticsService";
import AnalyticsContext from "@app/util/contexts/AnalyticsContext";
import useAnalytics from "@app/util/contexts/useAnalytics";

import styles from "./Emails.module.scss";

interface EmailsProps {
  emailServiceSupported: boolean;
  entity: EntitiesSupportedByEmailFeature;
}

const Emails: React.FC<EmailsProps> = ({ emailServiceSupported, entity }) => {
  const intl = useIntl();
  const analytics = useExtendedAnalytics("Emails", useAnalytics());

  if (!emailServiceSupported) {
    return <EmailsNotSupported className={styles.emailsNotSupported} />;
  }

  return (
    <AnalyticsContext.Provider value={analytics}>
      <TabLayout
        action={<EntityEmailsFolder />}
        title={intl.formatMessage({
          id: "recordPane.emails.title",
          defaultMessage: "Emails",
          description: "Title of a Emails section on a record pane",
        })}
      >
        <EntityEmails entity={entity} />
      </TabLayout>
    </AnalyticsContext.Provider>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailServiceSupported: isEmailServiceSupported(state),
});

export default connect(mapStateToProps)(Emails);
